import ms from 'ms'

import { ordersAtomDefinition } from './atoms/index.js'
import ordersModuleDefinition from './module/index.js'
import ordersMonitorDefinition from './monitor/index.js'
import ordersLifecyclePluginDefinition from './plugin/index.js'
import ordersAnalyticsPluginDefinition from './plugin/analytics.js'
import ordersReportDefinition from './report/index.js'

const DEFAULT_MONITOR_TICK = ms('30s')

const DEFAULT_BASE_URL = 'https://exchange-s.exodus.io/v3'

const DEFAULT_TX_TYPES = {
  PRE_SETUP: 'preSetupTransaction',
  SETUP: 'setupTransaction',
  SWAP: 'swapTransaction',
  CLEANUP: 'cleanupTransaction',
  DEPOSIT: 'depositTransaction',
  PAYOUT: 'payoutTransaction',
}

const orders = (config = Object.create(null)) => {
  const {
    appName,
    appVersion,
    supportedSvcs,
    baseUrl = DEFAULT_BASE_URL,
    txTypes = DEFAULT_TX_TYPES,
    monitorInterval = DEFAULT_MONITOR_TICK,
    optimisticActivityEnabled = false,
    orderStatusUpdateStrategy,
  } = config

  return {
    id: 'orders',
    definitions: [
      {
        definition: ordersModuleDefinition,
        config: { optimisticActivityEnabled, supportedSvcs },
      },
      {
        definition: ordersMonitorDefinition,
        config: {
          optimisticActivityEnabled,
          interval: monitorInterval,
          appName,
          appVersion,
          baseUrl,
          txTypes,
          orderStatusUpdateStrategy,
        },
      },
      { definition: ordersLifecyclePluginDefinition },
      {
        if: { registered: ['analytics'] },
        definition: ordersAnalyticsPluginDefinition,
      },
      { definition: ordersReportDefinition },
      {
        definition: ordersAtomDefinition,
        aliases: [
          {
            implementationId: 'unsafeStorage',
            interfaceId: 'storage',
          },
        ],
        storage: {
          namespace: 'orders',
        },
      },
    ],
  }
}

export default orders
